export const currencyFormatter = (
  v: unknown,
  fallback: string = "N/A",
): string => {
  if (typeof v !== "number" || !Number.isFinite(v)) {
    return fallback;
  }

  return `$${v.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
};

export const numberFormatter = ({
  v,
  minDecimal = 2,
  maxDecimal = 2,
}: {
  v: number;
  minDecimal?: number;
  maxDecimal?: number;
}): string =>
  v.toLocaleString("en-US", {
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal,
  });

export const numberAbbreviationFormatter = (value: number): string => {
  let formatted = value.toString();

  if (value >= 1_000_000) {
    const millions = value / 1_000_000;
    const truncated = Math.floor(millions * 10) / 10;
    formatted = Number.isInteger(truncated)
      ? truncated.toFixed(0)
      : truncated.toFixed(1);
    return `${formatted}M`;
  }

  if (value >= 1_000) {
    const thousands = value / 1_000;
    const truncated = Math.floor(thousands * 10) / 10;
    formatted = Number.isInteger(truncated)
      ? truncated.toFixed(0)
      : truncated.toFixed(1);
    return `${formatted}K`;
  }

  return formatted;
};

export const formatPercent = (value: number): string =>
  `${parseFloat(value.toFixed(2))}%`;

export const formatCurrency = (
  amount: number | string,
  options?: Intl.NumberFormatOptions,
): string => {
  const numericAmount =
    typeof amount === "string" ? parseFloat(amount) : amount;
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    ...options,
  });
  return formatter.format(numericAmount);
};

export const formatCurrencyWithRound = (
  amount: number,
  options?: Intl.NumberFormatOptions,
): string => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  });
  return formatter.format(Math.round(amount));
};

export const isJSON = (str: unknown): str is string => {
  if (typeof str !== "string") {
    return false;
  }

  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};
